import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=c13a58ba&scoped=true&"
import script from "./CommonFooter.vue?vue&type=script&lang=js&"
export * from "./CommonFooter.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=c13a58ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13a58ba",
  null
  
)

export default component.exports